module.exports = __webpack_public_path__ + "assets/img/music_category_default.b4fb4d16.png";